<template>
  <div class="inner-page case-overview">
    <AppHead :title="`Case #${thisCase.enquiry_number ? thisCase.enquiry_number : hashid}`" />

		<PageHeader 
      :title="`Case #${thisCase.enquiry_number ? thisCase.enquiry_number : hashid}`"
      desc="Details about an individual case"
      :hasButton="false"
      :showHelper="true"
      helpTitle="This is an individual Case"
      helpDesc="You can progress through the steps, complete your enquiry, upload required files and proceed to a design meeting. You can also communicate with messages."
      >
      <AdminActionBox
        v-if="permissions.viewProjectAdmin"
        :thisCase="thisCase"
        :viewers="viewers"
        :editors="editors"
        :availableUsers="availableUsers"
        :permissions="permissions"
        :anatomies="anatomies"
        :techFiles="techFiles"
        :caseFeatures="caseFeatures"
        :notifiableUsers="notifiableUsers"
        />
    </PageHeader>

    <CaseProgressBar 
      :step="thisCase.progress_stage" 
      :advancedMode="true"
      :thisCase="thisCase"
      :permissions="permissions"
      />

    <NextStep 
      :step="thisCase.progress_stage"
      :caseID="thisCase.hashid"
      :status="thisCase.status"
      :thisCase="thisCase"
      :permissions="permissions"
      v-if="!['admin', 'team_admin'].includes($page.props.user.user_type)"
      />
    
    <CaseGrid
      :thisCase="thisCase"
      :chat="chat"
      :userId="userId"
      :isAdmin="isAdmin"
      :projectUser="projectUser"
      :permissions="permissions"
      :treatmentPlans="treatmentPlans"
      :ifus="ifus"
      :images="images"
      :enquiries="enquiries"
      :hashid="hashid"
      :forms="forms"
      :filledFormsCount="filledFormsCount"
      />


  </div>
</template>

<script>

import AppLayout from "@/Layouts/AppLayout.vue"
import AppHead from "@/Components/AppHead"
import PageHeader from "@/Components/PageHeader"
import CaseProgressBar from "@/Components/Cases/CaseProgressBar"
import NextStep from "@/Components/Cases/NextStep"
import CaseGrid from '@/Components/Cases/CaseGrid.vue'
import AdminActionBox from "@/Components/Admin/AdminActionBox"


export default {
  props: [
    'thisCase',
    'enquiries',
    'images',
    'treatmentPlans',
    'ifus',
    'hashid',
    'chat',
    'userId',
    'projectUser',
    'viewers',
    'editors',
    'availableUsers',
    'permissions',
    'anatomies',
    'techFiles',
    'caseFeatures',
    'forms',
    'filledFormsCount',
    'notifiableUsers'
  ],
	components: {
		AppLayout,
    AppHead,
    PageHeader,
    CaseProgressBar,
    NextStep,
    CaseGrid,
    AdminActionBox
	},
	layout: AppLayout,
  data: () => {
    return {
      
    }
  },
  methods: {
  },
  computed: {
    isAdmin(){
      return ['admin', 'team_admin'].includes(this.$page.props.user.user_type)
    }
  }
};

</script>

<style scoped lang="sass">

// .case-overview
  

</style>